/**
 * @file Route: storelocator
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import "components/Title";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import { StoreLocator } from "components/StoreLocator";
import "components/Searchaddress";
import "components/Related";
import "./index.scss";

console.log("Route storelocator/index.js mounted.");
 
replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();
StoreLocator();
// Searchaddress();

dataLayer.push({
    'event': 'store_locator',
    'click_type': 'search',
    'element_clicked': 'page load',
});

document.addEventListener('input', function (e) {
    // console.log(e);
    if (e.target.classList.contains('gtm-filter')) {
        // push to datalayer
        dataLayer.push({
            'event': 'store_locator',
            'click_type': 'filter',
            'element_clicked': e.target.value,
        });
    }
});

document.addEventListener('click',function(e){
    // console.dir(e.target);
    if (e.target.classList.contains('gtm-info')) {
        // push to datalayer
        dataLayer.push({
            'event': 'store_locator',
            'click_type': 'store_info',
            'element_clicked': e.target.getAttribute('data-info'),
            'store_name': e.target.getAttribute('data-name'),
        });
    }
});